const state = {
  visible: false,
  mode: 'login',
  returnTo: null,
}

const mutations = {
  OPEN_MODAL(state, payload) {
    state.visible = true
    state.mode = payload && payload.mode ? payload.mode : 'login'
    state.returnTo = payload && payload.returnTo ? payload.returnTo : null
  },
  CLOSE_MODAL(state) {
    state.visible = false
    state.mode = 'login'
    state.returnTo = null
  },
}

const actions = {
  openModal({ commit }, payload) {
    commit('OPEN_MODAL', payload || {})
  },
  closeModal({ commit }) {
    commit('CLOSE_MODAL')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
